import { gql } from '@apollo/client'

const BASE_REWARDS_FIELDS = gql`
  fragment BaseRewardsFields on RewardType {
    id
    isLive
    type
    value
    percentage
    platform {
      id
    }
    description
    countOfEarnedRewards
    order
  }
`

export const FIND_ALL_REWARDS = gql`
  ${BASE_REWARDS_FIELDS}
  query FindAllReward($query: RewardQueryInput!) {
    findAllReward(query: $query) {
      items {
        ...BaseRewardsFields
      }
    }
  }
`

export const FIND_REWARD = gql`
  ${BASE_REWARDS_FIELDS}
  query FindOneReward($id: String!) {
    findOneReward(id: $id) {
      ...BaseRewardsFields
    }
  }
`

export const CREATE_REWARD = gql`
  ${BASE_REWARDS_FIELDS}
  mutation CreateReward($createInput: CreateRewardInput!) {
    createReward(createRewardInput: $createInput) {
      ...BaseRewardsFields
    }
  }
`

export const UPDATE_REWARD = gql`
  ${BASE_REWARDS_FIELDS}
  mutation UpdateReward($updateInput: UpdateRewardInput!) {
    updateReward(updateRewardInputFieldName: $updateInput) {
      ...BaseRewardsFields
    }
  }
`

export const BULK_UPDATE_REWARDS = gql`
  mutation bulkUpdateReward($bulkUpdateInput: [BulkUpdateRewardInput!]!) {
    bulkUpdateReward(bulkUpdateRewardInput: $bulkUpdateInput) {
      id
    }
  }
`
